import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import ProjectActionsWithCapabilitiesQuery, {
	type ProjectActionsWithCapabilitiesQuery as ProjectActionsWithCapabilitiesQueryType,
} from '@townsquare/project-actions/project-capabilities';
import type { ResourceContext } from '@townsquare/router/types';

export const projectCapabilitiesResource = createRelayResource<ProjectActionsWithCapabilitiesQueryType>({
	getQuery: (_, resourceContext) => {
		const containerId = (resourceContext as ResourceContext).collabContext?.contextId ?? '';

		return {
			query: ProjectActionsWithCapabilitiesQuery,
			environment: getAggRelayEnvironment(),
			variables: {
				containerId,
			},
		};
	},
});
